import { createContext, useContext } from 'react';

import { INITIAL_SESSION, Session } from './session.context.model';

export const SessionContext = createContext<[Session, (session: Session) => void]>([
  INITIAL_SESSION,
  () => {},
]);
export const useSessionContext = () => useContext(SessionContext);
